const conf = {
  ninjaCommentSiteId: "ec72f46b-042c-43ff-9fe0-1b26192462b8",
  anonymousEmail: "20130075@student.hust.edu.vn"
}

export default conf